import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import useModalContext from '@hooks/context/useModalContext';

const CancelBillScheduleModal = () => {
    // const { t } = useTranslation('modals', {
    //     keyPrefix: 'delete_wallet_account'
    // });
    const { modalData } = useModalContext();
    return (
        <div className={styles.wrapper}>
            <Typography className={styles.title} variant="h4" alignment="center">
                Cancel payment
            </Typography>
            <div className={styles.description}>
                Are you sure you want to cancel scheduled bill payment to {modalData?.name} This
                action cannot be undone.
            </div>
        </div>
    );
};

export default CancelBillScheduleModal;
